import React from "react";
import { Helmet } from "react-helmet-async";
import PropTypes from "prop-types";

const PageStructuredData = ({ description, name, breadcrumbs }) => {
    const breadcrumbList = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: breadcrumbs,
    };

    const schemas = {
        "@context": "http://schema.org",
        "@type": "WebPage",
        name,
    };

    if (description) {
        schemas["description"] = description;
    }

    return (
        <Helmet>
            <script type="application/ld+json">{JSON.stringify(schemas, null, 2)}</script>
            {!!breadcrumbs.length && (
                <script type="application/ld+json">{JSON.stringify(breadcrumbList, null, 0)}</script>
            )}
        </Helmet>
    );
};

PageStructuredData.propTypes = {
    breadcrumbs: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    description: PropTypes.string,
    name: PropTypes.string.isRequired,
};

PageStructuredData.defaultProps = {
    description: null,
};

export default PageStructuredData;
